import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Sort } from '@app/classes';
import { Header } from '@app/shared';

@Component({
  selector: '[sortable-table-header]',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent implements OnInit {
  @Input() headers: Header[] = [];
  @Output() onSort: EventEmitter<Sort[]> = new EventEmitter<Sort[]>();

  sort: Sort[] = [];

  ngOnInit() {
    this.sort = this.headers.filter((x) => x.sortable).map((x) => new Sort({ columnName: x.visibleName, property: x.name, active: 0 }));
    const defaultHeader = this.headers.find((x) => x.default);
    if (!defaultHeader) return;
    this.sort.find((x) => x.columnName === defaultHeader.visibleName)?.setSort();
  }

  onSortChange(header: Header) {
    for (const s of this.sort) {
      if (s.columnName === header.visibleName) continue;
      s.deactivate();
    }
    this.sort.find((x) => x.columnName === header.visibleName)?.setSort();
    this.onSort.emit(this.sort);
  }

  headerIcon(columnName: string): string {
    return this.sort.find((x) => x.columnName === columnName)?.icon ?? '';
  }
}
